declare const window: Window & { dataLayer?: any[] }

export function pushAxonEvent(eventName: string, params: Record<string, any>, options: Record<string, any> = {}) {
  window.dataLayer = window.dataLayer || []

  if (params.items !== undefined)
    window.dataLayer.push({ items: null })
  window.dataLayer.push({ event: eventName, ...params, ...options })
}

export function buildAxonItem(productId: string | number, productName: string, price: string | number) {
  return {
    item_id: String(productId),
    item_name: productName,
    price: Number(price),
    quantity: 1,
  }
}
